import { render, staticRenderFns } from "./PracticeAssociate.vue?vue&type=template&id=40d37c7c&scoped=true"
import script from "./PracticeAssociate.vue?vue&type=script&lang=js"
export * from "./PracticeAssociate.vue?vue&type=script&lang=js"
import style0 from "./PracticeAssociate.vue?vue&type=style&index=0&id=40d37c7c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40d37c7c",
  null
  
)

export default component.exports